import React from 'react'
import { flightCardBadge, getFlightCardStatus } from './flightCardStatus'

// RD-4141: the status badge in a flight card's dropdown header. Uses the header's existing
// .flightStatus (green) / .flight-delayed (red) styles; the state itself comes from the same
// model the card body uses, so header and card always agree.
export default function FlightStatusBadge({
  flightInfo,
  delayDepartureTime,
  delayArrivalTime,
  progressPercentage,
}) {
  if (!flightInfo) return null
  const status = getFlightCardStatus({
    flightInfo,
    delayDepartureTime,
    delayArrivalTime,
    progressPercentage,
  })
  const { label, tone } = flightCardBadge(status)
  return (
    <div className={tone === 'red' ? 'flight-delayed' : 'flightStatus'}>
      {label}
    </div>
  )
}
